import { createSlice } from "@reduxjs/toolkit";

export const ActionRequiredIndicator = createSlice({
  name: "Indicator-Dialog-Box",
  initialState: {
    value: {
      status: false,
      message: "",
      title: "",
      indicatorLabel: "",
      isIndicatorOpen: false,
      showIndicator: false,
    },
  },
  reducers: {
    updateIndicatorContent: (state, action) => {
      state.value.status = true;
      state.value.message = action?.payload?.message
        ? action?.payload?.message
        : "";
      state.value.title = action?.payload?.title ? action?.payload?.title : "";

      state.value.indicatorLabel = action?.payload?.indicatorLabel
        ? action?.payload?.indicatorLabel
        : "profile-setup";
      state.value.isIndicatorOpen = action?.payload?.isIndicatorOpen
        ? action?.payload?.isIndicatorOpen
        : state.value.isIndicatorOpen;
    },
    openIndicator: (state, action) => {
      state.value.isIndicatorOpen = true;
    },
    closeIndicator: (state, action) => {
      state.value.isIndicatorOpen = false;
    },
    showTopBarIndicator: (state, action) => {
      state.value.showIndicator = action?.payload;
    },
    clearIndicatorState: (state) => {
      state.value.status = false;
      state.value.message = "";
      state.value.title = "";
      state.value.indicatorLabel = "";
      state.value.isIndicatorOpen = false;
      state.value.showIndicator = false;
    },
  },
});

export const {
  updateIndicatorContent,
  openIndicator,
  closeIndicator,
  clearIndicatorState,
  showTopBarIndicator,
} = ActionRequiredIndicator.actions;

export default ActionRequiredIndicator.reducer;
